import useTranslator from "../../hooks/useTranslator";
import CloseIcon from "../../assets/img/closeIcon.svg";
import { useContext, useEffect, useState } from "react";
import { haveValue, toast } from "../../helper/common";
import FlatmateDetailCard from "./FlatmateDetailsCard";
import { useNavigate,useParams } from "react-router-dom";
import axiosInstance from "../../services/authWrapper";
import PendingSharerPill from "./PendingSharerPill";
import DeleteConfiration from "./DeleteConfiration";
import AuthContext from "../../context/auth/AuthContext";
import TenantContext from "../../context/tenant/TenantContext";

const FlatmateModel = ({
  user,
  isOpen,
  sharerData,
  onClose,
  llShowOnly,
  setSelectedUser,
  setFlatmateAddFormModal,
  setShowModal,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { workspaceId } = useParams();
  const { loadUser } = useContext(AuthContext);
  const { deleteSharer } = useContext(TenantContext);

  const [loadingStates, setLoadingStates] = useState({});
  const [pendingSharers, setPendingSharers] = useState([]);
  const [showDeleteConfirmationPrompt, setShowDeleteConfirmationPrompt] =
    useState(false);
  const [selectedSharer, setSelectedSharer] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    const pendingSharers = (
      user?.tenant_extra_field_id?.selected_onboarding_users ?? []
    ).filter((item) => item?.type === "sharer");
    setPendingSharers(pendingSharers);
  }, [user]);

  const goToProfile = (sharer) => {
    if (haveValue(sharer?.sharerId)) {
      navigate(
        `/${workspaceId}/profile-property?sharedprofileid=${sharer?.sharerId}`
      );
    }
    if (haveValue(sharer?.agencySharerId)) {
      {
        navigate(
          `/${workspaceId}/profile-property?agencylink=${sharer?.agencySharerId}`
        );
      }
    }
  };

  const sendShareProfileEmail = async (data) => {
    await axiosInstance
      .post(
        `${process.env.REACT_APP_SERVER_URL}/shared-profile/sendShareProfileEmail`,
        {
          sharerName: data.sharerName,
          sharerEmail: data.sharerEmail,
          tenantId: data.tenantId,
          landlordId: data.landlordId,
        },
        { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
      )
      .then((res) => {})
      .catch((err) => {});
  };

  //Handlers
  const handleClick = async (sharer) => {
    // Set loading state for this sharer
    setLoadingStates((prevState) => ({
      ...prevState,
      [sharer.email]: true,
    }));

    if (haveValue(sharer?.sharerId) || haveValue(sharer?.agencySharerId)) {
      // Navigate to profile
      goToProfile(sharer);
    } else {
      try {
        // Send share profile email
        await sendShareProfileEmail({
          sharerName: sharer.name,
          sharerEmail: sharer.email,
          tenantId: user._id,
          landlordId: localStorage.getItem("saveduserid"),
        });
        toast.success(_t("Invitation link sent successfully"));
      } catch (error) {
        toast.error(error.message);
        console.error("Error sending email:", error);
      }
    }

    // Reset the loading state for this sharer once the operation is complete
    setLoadingStates((prevState) => ({
      ...prevState,
      [sharer.email]: false,
    }));
  };

  const handleDeleteSharer = async () => {
    if (!selectedSharer?._id) return;
    try {
      setDeleteLoading(true);
      await deleteSharer(selectedSharer?._id);
      setSelectedSharer(null);
      setShowDeleteConfirmationPrompt(false);
      setShowModal(true);
      loadUser("tenant");
    } catch (error) {
      toast.error(_t("failedToDeleteSharer"));
    } finally {
      setDeleteLoading(false);
    }
  };

  if (!isOpen) return;

  return (
    <div className="wrapper-modal" onClick={onClose}>
      <div
        className={`doc-history-popup total-salary-modal ${
          isOpen ? "open" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <span className="drawerIcon" onClick={onClose} />
        <div>
          <div className="doc-history-header">
            <img
              src={CloseIcon}
              alt=""
              className="doc-history-close-btn"
              onClick={onClose}
            />
            <h4 className="custom-modal-heading">{_t("flatmates")}</h4>
          </div>
          <div
            className="earner-card-wrapper pending-guarantor-wrapper"
            style={{
              height:
                pendingSharers?.length === 0 && sharerData?.length > 5
                  ? "55vh"
                  : sharerData?.length > 5
                  ? "48vh"
                  : "auto",
            }}
          >
            {(sharerData ?? []).map((flatmate, index) => (
              <FlatmateDetailCard
                key={index}
                sharer={flatmate}
                handleClick={handleClick}
                loadingStates={loadingStates}
                llShowOnly={llShowOnly}
                setShowDeleteConfirmationPrompt={
                  setShowDeleteConfirmationPrompt
                }
                setSelectedSharer={setSelectedSharer}
              />
            ))}
          </div>

          {!llShowOnly && (
            <>
              {pendingSharers.length > 0 && (
                <div>
                  <h4 className="guarantor-pending-heading pending-flatmates-heading">
                    {_t(
                      "pendingFlatmates",
                      "New tenant side on guarantor side bar for pending requests"
                    )}
                  </h4>
                </div>
              )}
              <div
                className="earner-card-wrapper pending-guarantor-wrapper"
                style={{
                  height:
                    sharerData?.length === 0 && pendingSharers?.length > 5
                      ? "55vh"
                      : pendingSharers?.length > 5
                      ? "48vh"
                      : "auto",
                }}
              >
                {pendingSharers.map((data) => (
                  <PendingSharerPill
                    data={data}
                    setFlatmateAddFormModal={setFlatmateAddFormModal}
                    setSelectedUser={setSelectedUser}
                  />
                ))}
              </div>
              <div className="addGuarantorButtonWrapper d-flex align-items-center justify-content-center">
                <button
                  className="addGuarantorButton d-flex align-items-center justify-content-center"
                  onClick={() => {
                    setSelectedUser(null);
                    onClose();
                    setFlatmateAddFormModal(true);
                  }}
                >
                  <img src="/images/add-white.svg" alt="" />
                  {_t("addFlatmates")}
                </button>
              </div>
            </>
          )}
          <DeleteConfiration
            isOpen={showDeleteConfirmationPrompt}
            onClose={() => setShowDeleteConfirmationPrompt(false)}
            name={selectedSharer?.name ?? ""}
            relation={selectedSharer?.relation ?? ""}
            heading={_t("deleteRentalSharer")}
            description={"areYouSureDoYouWantToDeleteThisRenatalSharer"}
            btn1Text={_t("noGoBack")}
            btn2Text={_t("yesDelete")}
            btn1Functionality={() => setShowDeleteConfirmationPrompt(false)}
            btn2Functionality={handleDeleteSharer}
            submitLoading={deleteLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default FlatmateModel;
